import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion, faWarning, faXmark } from '@fortawesome/pro-light-svg-icons';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { IntercomIcon } from '../display/intercom-icon';
import { toast, ToastContentProps } from 'react-toastify';
import { useIntercom } from 'react-use-intercom';
import { useJiraSupportEnabled } from '@/utils/feature-flags';
import { reportAProblemUrl } from '@/utils/support-url';

export function showErrorToast(message?: string) {
  toast(toastProps => <ErrorToast message={message} {...toastProps} />);
}

type Props = { message?: string } & ToastContentProps;

function ErrorToast({ message, closeToast }: Props) {
  const { showNewMessage: showNewIntercomMessage } = useIntercom();
  const jiraSupportEnabled = useJiraSupportEnabled();
  const displayedMessage = message || 'There was an error getting data for this page.';

  return (
    <div className="flex w-full items-center rounded-lg bg-red-600">
      <FontAwesomeIcon icon={faWarning} className="h-7 w-7 px-2 text-red-300" />
      <div className="flex w-full items-center justify-between gap-4 rounded-lg bg-red-200 p-2 pl-4">
        <div className="text-gray-800">
          <div className="mb-1 font-semibold">{displayedMessage}</div>
          <div className="text-sm">
            {jiraSupportEnabled
              ? 'If the issue continues, submit a support request.'
              : 'If the issue continues, send a message using Intercom.'}
          </div>
        </div>
        <div className="flex flex-col items-end justify-between gap-1">
          <div
            className="flex cursor-pointer rounded-sm bg-red-300 px-1 py-0.5"
            onClick={closeToast}>
            <FontAwesomeIcon size="lg" className="text-gray-600" icon={faXmark} />
          </div>
          {jiraSupportEnabled ? (
            <a
              href={reportAProblemUrl(displayedMessage)}
              target="_blank"
              rel="noreferrer"
              className="flex cursor-pointer gap-2 rounded-sm rounded-l-3xl bg-[#0171B2] p-2 pl-3 no-underline">
              <FontAwesomeIcon color="white" icon={faCircleQuestion} />
              <FontAwesomeIcon color="white" icon={faArrowRight} mask={['fal', 'arrow-right']} />
            </a>
          ) : (
            <div
              className="flex cursor-pointer gap-2 rounded-sm rounded-l-3xl bg-[#0171B2] p-2 pl-3"
              onClick={() => showNewIntercomMessage()}>
              <IntercomIcon height={16} width={14} />
              <FontAwesomeIcon color="white" icon={faArrowRight} mask={['fal', 'arrow-right']} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
